import ThirdOverview from './ThirdOverview'

class SupplierOverview extends ThirdOverview {

    constructor() {
        super()
        this.linkedtype = 'supplier'
        this.setMappingName()
    }
}

export default SupplierOverview